import { Config } from "../../config/Config";
import { Building } from "../../building/Building";
import { AddonManager } from "../addon/AddonManager";
import { Object3D } from "three";
import { RoofAddon } from "../addon/RoofAddon";
import { PostManager } from "../../building/post/PostManager";

export class RidgeVent
{

	public static MODE_CONTINUOUS = "continuous";
	public static MODE_EVEN       = "even";

	public static TYPE_STANDARD   = "standard";
	public static TYPE_LOW        = "low";
	public static TYPE_NONE       = "none";

	private _config:Config;
	private _scene:Object3D;

	// current ridge vents
	private _vents:RoofAddon[];

	constructor(building:Building)
	{
		this._config = building.config;
		this._scene  = building.scene3D;
		this._vents = [];

		this._config.building.length.signal.add(this.onBuildingLengthChange);

		this._config.building.height.signal.add(this.onBuildingSizeChange);
		this._config.building.pitch.signal.add(this.onBuildingSizeChange);
		this._config.building.width.signal.add(this.onBuildingSizeChange);

		this._config.building.single_slope.signal.add(this.onSingleSlopeChange);

		this.init();
	}

	private init()
	{
		var type = this._config.building.ridge_vent_type;
		var mode = this._config.building.ridge_vent_mode;

		type.signal.add(this.onTypeChange);
		mode.signal.add(this.onModeChange);

		this.onTypeChange(type.value);
		this.onModeChange();
	};

	private onTypeChange = (value:string) =>
	{
		this.removeRidgeVents();

		if (value !== RidgeVent.TYPE_NONE)
		{
			this.createRidgeVents();

			this.onBuildingSizeChange();
			this.onBuildingLengthChange();
		}
	};

	private onModeChange = () =>
	{
		this.removeRidgeVents();
		this.createRidgeVents();

		this.onBuildingSizeChange();
		this.onBuildingLengthChange();
	};

	private onBuildingSizeChange = () =>
	{
		for (var i = 0; i < this._vents.length; ++i)
		{
			this._vents[i].updatePosition();
		}
	};

	private onSingleSlopeChange = (value: string) =>
	{
		//for (var i = 0; i < this._vents.length; ++i)
		//{
		//	if (value)
		//	{
		//		this._vents[i].hide();
		//	}
		//	else
		//	{
		//		this._vents[i].show();
		//	}
		//}
	}

	private onBuildingLengthChange = () =>
	{

		if (<any>this._config.building.ridge_vent_type.value === RidgeVent.TYPE_NONE)
		{
			return;
		}

		var length = this._config.building.length.value;

		var mode = this._config.building.ridge_vent_mode.value;
		if (mode)
		{
			// if the number of vents changes -> remove/add vents
			var numberOfVents  = this.getNumberOfVents();
			var ventsCurrently = this._vents.length;
			var ventsDiff      = numberOfVents - ventsCurrently;

			if (ventsDiff > 0)
			{
				// add missing vents

				var type = <any>this._config.building.ridge_vent_type.value;

				for (var i = 0; i < ventsDiff; ++i)
				{
					this.addRidgeVent(type);
				}
			}
			else if (ventsDiff < 0)
			{
				// remove unneeded vents

				for (i = 0; i < -ventsDiff; ++i)
				{
					var vent = this._vents.pop();
					vent.removeFromScene(this._scene);
				}
			}

			// align vents

			if (numberOfVents === 1)
			{
				// align centered

				this._vents[0].setPosition(0);
			}
			else
			{
				// evenly spread

				var len = length;

				for (var i = 0; i < numberOfVents; ++i)
				{
					var z = (-len/2 + i / numberOfVents * len) + (len / numberOfVents / 2);
					this._vents[i].setPosition(z);
				}
			}
		}
		else// if (mode === RidgeVent.MODE_CONTINUOUS)
		{
			// scale the one item we have

			if (!this._vents[0])
			{
				this.onModeChange();
			}

			this._vents[0].setLength(length);
		}
	};

	private createRidgeVents()
	{
		var type = this._config.building.ridge_vent_type.value;
		var mode = this._config.building.ridge_vent_mode.value;

		if (type === RidgeVent.TYPE_NONE)
		{
			return;
		}

		if (mode) // spread
		{
			var numberOfVents = this.getNumberOfVents();

			for (var i = 0; i < numberOfVents; ++i)
			{
				this.addRidgeVent(type);
			}
		}
		else
		{
			this.addRidgeVent(type);
		}
	}

	private removeRidgeVents()
	{
		var vents = this._vents;

		for (var i = 0, ln = vents.length; i < ln; ++i)
		{
			vents[i].removeFromScene(this._scene);
		}

		this._vents.length = 0;
	}

	private addRidgeVent(type:string)
	{
		var vent = this.createRidgeVent(type);
		vent.show(); //todo
		vent.addToScene(this._scene);
		this._vents.push(vent);

		return vent;
	}

	private createRidgeVent(type:string):RoofAddon
	{
		var vent = null;

		var pitch = this._config.building.pitch;

		if (type === "low")
		{
			vent = new RoofAddon({
				id: "low_vent",
				label: "Low Profile Vent",
				mesh: {
					"1": "Low Profile Vent - 1/12 Pitch",
					"2": "Low Profile Vent - 2/12 Pitch",
					"3": "Low Profile Vent - 3/12 Pitch",
					"4": "Low Profile Vent - 4/12 Pitch",
					"5": "Low Profile Vent - 4/12 Pitch"
				},
				type: "roof",
				size: {
					length: 8
				},
				color: "vent",
				pitch: pitch
			});
		}

		if (type === "standard")
		{
			vent = new RoofAddon({
				"id": "standard_vent",
				"label": "Standard Vent",
				"mesh": {
					"1": "Standard Vent - 1/12 Pitch",
					"2": "Standard Vent - 2/12 Pitch",
					"3": "Standard Vent - 3/12 Pitch",
					"4": "Standard Vent - 4/12 Pitch",
					"5": "Standard Vent - 4/12 Pitch"
				},
				"type": "roof",
				"size": {
					"length": 8
				},
				"color": "vent",
				"pitch": pitch
			});
		}

		return vent;
	}

	private getNumberOfVents(): number
	{
		return Math.ceil(this._config.building.length.value / PostManager.IntervalOnSide);
	}
}